import * as R from 'ramda';
import styled, { keyframes } from 'styled-components';
import { space, width, height, layout, zIndex, maxWidth } from 'styled-system';
// helpers/constants
import * as G from '../../helpers';
//////////////////////////////////////////////////

export const animation = (props) => {
  const from = props.params.position.split('-')[0];
  const moves = {
    top: keyframes`
      0% { top: -${props.params.height}px }
      100% { top: 0 }
    `,
    bottom: keyframes`
      0% { bottom: -${props.params.height}px }
      100% { bottom: 0 }
    `,
  };
  return moves[from];
};

export const modalStyles = {
  frameWidth: 6,
  radius: '14px',
  dragBarHeight: 22,
  frameBlur: 'blur(2px)',
  bgColor: G.getTheme('colors.white'),
  frameBgColor: 'rgba(255, 255, 255, 0.45)',
  borderColor: G.getTheme('colors.#EDEFF1'),
  subTextColor: G.getTheme('colors.#7D828C'),
  headerBgColor: G.getTheme('colors.offWhite'),
  textColor: G.getTheme('colors.dark.mainDark'),
  overlayBgColor: G.getTheme('colors.mainDarkTransparent'),
};

export const isFullHeight = ({ height }) => R.includes(height, ['100vh', '100dvh']);

const getFrameStyles = (params) => {
  if (isFullHeight(params)) return 'padding: 0px;';

  const { radius, frameWidth, frameBlur, dragBarHeight, frameBgColor } = modalStyles;

  const paddingTop = G.ifElse(params.withDragBar, dragBarHeight, frameWidth);

  return `
    padding: ${frameWidth}px;
    padding-top: ${paddingTop}px;
    border-radius: calc(${radius} + ${frameWidth}px);

    &::before {
      inset: 0;
      content: '';
      position: absolute;
      pointer-events: none;
      border-radius: inherit;
      background: ${frameBgColor};
      backdrop-filter: ${frameBlur};
    }
  `;
};

export const ModalWrapper = styled.div`
  ${maxWidth}

  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  background: ${modalStyles.overlayBgColor};
  z-index: ${({ index = 0 }) => R.add(index, 1300)};
`;

export const ModalWrapperWithZIndex = styled.div`
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  background: ${modalStyles.overlayBgColor};
  z-index: ${({ zIndex }) => zIndex || 11};
`;

export const Title = styled.span`
  font-weight: bold;
`;

export const ModalContentWrapper = styled.div`
  ${space}
  ${layout}
  ${zIndex}

  display: flex;
  position: relative;
  flex-direction: column;
  box-sizing: content-box;

  ${({ params }) => getFrameStyles(params)}
`;

export const ModalCard = styled.div`
  width: 100%;
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  position: relative;
  flex-direction: column;

  overflow: ${({ params }) => params.overflow || 'auto'};
  background-color: ${({ params }) => params.backgroundColor || modalStyles.bgColor};
  border-radius: ${({ params }) => G.ifElse(isFullHeight(params), '0px', modalStyles.radius)};
`;

export const Header = styled.div`
  ${space}
  ${width}
  ${height}

  width: 100%;
  line-height: 20px;
  padding: 10px 15px;
  align-items: center;
  display: inline-flex;
  justify-content: space-between;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  cursor: ${({ cursor }) => cursor};
  user-select: ${({ userSelect }) => userSelect};
  color: ${({ color }) => color || modalStyles.textColor};
  border-bottom: 1px solid ${() => modalStyles.borderColor};
  background-color: ${({ backgroundColor }) => backgroundColor || modalStyles.headerBgColor};
`;

export const Footer = styled.div`
  right: 0;
  width: 100%;
  display: flex;
  text-align: center;
  padding: ${({ p }) => p || '15px'};
  bottom: ${({ bottom }) => bottom || 0};
  z-index: ${({ zIndex }) => zIndex || 9};
  position: ${({ position }) => position || 'absolute'};
  justify-content: ${({ justifyContent }) => justifyContent || 'space-between'};
`;
